module.exports = __webpack_public_path__ + "static/media/plan-for.e81bd227.svg";